import { useState,useEffect } from 'react';
import Slider from 'react-slick';
import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";
import HomePageData from './home-data';
import { Link } from 'react-router-dom';



function OurServices() {
    const [view,setView]=useState({
		matches: window.innerWidth < 767 ? false : true ,
	  });
    const settings = {
        infinite: false,
        speed: 1000,
        arrows: false,
        slidesToShow: 7,
        autoplay: false,
        dots: false,
        autoplaySpeed: 2000,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                adaptiveHeight: true,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
              },
            },
        ],
    };

    useEffect(() => {
        let mediaQuery = window.matchMedia("(min-width: 767px)");
        mediaQuery.addListener(setView);
        // this is the cleanup function to remove the listener
        return () => mediaQuery.removeListener(setView);
      }, []);


  return (
    <>
        <section className='services-section'>
            <div className='container'>
                <div className='section-heading'>
                    <h3 className='ttl1' >Services</h3>
                </div>
                <div>
                {
				view && !view.matches ? 
                <Slider {...settings} className='services-details'>
                        {HomePageData.OurSarvices.map((response, index) => (
                        <div className='services-items' key={index}>
                            <div className='services-card'>
                                    <div className='card-logo'>
                                        <img src={response.sImg} alt=""  width={64} height={64}/>
                                    </div>
                                    <h4>{response.sHeading}</h4>
                                    <p>{response.sDescription}</p>
                                    <Link to={response.sBtnLink} className='read-more-btn'><span>{response.sBtnText}</span></Link>
                                </div>
                            </div>
                        ))}
                    </Slider>
                    :
                    <div className='services-details'>
                    {HomePageData.OurSarvices.map((response, index) => (
                        <div className='services-items' key={index}>
                            <div className='services-card'>
                                    <div className='card-logo'>
                                        <img src={response.sImg} alt=""  width={64} height={64}/>
                                    </div>
                                    <h4>{response.sHeading}</h4>
                                    <p>{response.sDescription}</p>
                                    <Link to={response.sBtnLink} className='read-more-btn'><span>{response.sBtnText}</span></Link>
                                </div>
                            </div>
                        ))}
                    </div>
                }
                </div>
            
            </div>
      </section>
    </>
  )
}

export default OurServices
